/**
 * The set of org plan names the frontend understands. The backend will
 * eventually return these on `organization.plan.type`; until then the value is
 * hardcoded in `use-auth-state` and narrowed here via {@link parseOrgPlanName}.
 */
export const ORG_PLAN_NAMES = ["Healthie-Text"] as const;
export type OrgPlanName = (typeof ORG_PLAN_NAMES)[number];

/**
 * Integration record keys that may appear on {@link OrgOnboardingStatus}. Add-on
 * integrations extend this list; key presence in the status record means the
 * integration was selected during setup.
 */
export const INTEGRATION_NAMES = ["healthie", "twilio"] as const;
export type IntegrationName = (typeof INTEGRATION_NAMES)[number];

/**
 * The shape of `organization.onboardingStatus` — an open record matching the
 * backend type. Recognized keys:
 *
 * Per-step keys `"${integration}:${stepKey}"`, one per setup step:
 * - `"complete"` — the user completed the step.
 * - `"skipped"` — the user skipped the step.
 *
 * Per-integration keys, one per {@link INTEGRATION_NAMES} (key presence =
 * integration selected):
 * - `false` — selected, setup not started.
 * - `true` — integration setup is ready (its last step was completed); read by
 *   feature-gating.
 *
 * Whole-flow completion is derived from the per-step keys at runtime (see
 * `deriveSetupFlow` in `@tellescope/onboarding`), not stored.
 */
export type OrgOnboardingStatus = Record<string, string | boolean> | undefined;
